/**
 * Ссылки с принудительным форматом — на случай клиента, который не сообщает
 * себя в User-Agent или определяется неверно.
 *
 * Сервер по одному `/sublink/...` отдаёт разный формат по User-Agent
 * (sing-box JSON / mihomo YAML / base64 URI). Явный `?format=` — fallback.
 */

export interface ExplicitFormatLink {
  title: string
  href: string
  hint: string
}

export function buildExplicitFormatLinks(subLink: string): ExplicitFormatLink[] {
  if (!subLink) return []
  return [
    {
      title: 'sing-box JSON',
      href: `${subLink}?format=sing-box`,
      hint: 'SFA/SFI/SFM, Hiddify, Karing, NekoBox — с SSH',
    },
    {
      title: 'Clash (mihomo)',
      href: `${subLink}?format=clash`,
      hint: 'FlClash, Verge Rev, Mihomo Party, CMFA — с SSH',
    },
    {
      title: 'URI base64',
      href: `${subLink}?format=uri`,
      hint: 'v2rayN, Streisand, Shadowrocket — без SSH',
    },
  ]
}
